/**
 * Spacer Component Definition
 *
 * A simple spacing element for adding vertical or horizontal space.
 */

import { getResponsiveDimension } from '../../renderer/StyleResolver';

export const spacerComponent = {
  type: 'spacer',
  label: 'Spacer',
  icon: 'Minus',
  description: 'Add vertical or horizontal space',
  category: 'layout',

  canHaveChildren: false,

  resolveStyles(props, breakpoint) {
    let height;
    if (typeof props.height === 'number') {
      height = `${props.height}px`;
    } else if (props.height) {
      height = getResponsiveDimension(props.height, breakpoint);
    } else {
      height = '32px';
    }
    return {
      height,
      width: props.width || 'auto',
    };
  },

  defaultProps: {
    height: { base: { value: 32, unit: 'px' }, tablet: null, desktop: null },
    width: 'auto',
    showDivider: false,
    dividerColor: '#e5e7eb',
    dividerThickness: 1,

    // Custom CSS
    customCSS: '',
  },

  settingsSchema: [
    // Size category
    {
      key: 'height',
      type: 'responsiveDimension',
      label: 'Height',
      category: 'Size',
      default: { base: { value: 32, unit: 'px' }, tablet: null, desktop: null },
    },
    {
      key: 'width',
      type: 'select',
      label: 'Width',
      category: 'Size',
      default: 'auto',
      options: [
        { value: 'auto', label: 'Auto (Full Width)' },
        { value: '75%', label: '75%' },
        { value: '50%', label: '50%' },
        { value: '25%', label: '25%' },
      ],
    },

    // Divider category
    {
      key: 'showDivider',
      type: 'checkbox',
      label: 'Show Divider Line',
      category: 'Divider',
      default: false,
    },
    {
      key: 'dividerColor',
      type: 'color',
      label: 'Divider Color',
      category: 'Divider',
      default: '#e5e7eb',
      showWhen: { field: 'showDivider', equals: true },
    },
    {
      key: 'dividerThickness',
      type: 'number',
      label: 'Divider Thickness (px)',
      category: 'Divider',
      min: 1,
      max: 10,
      default: 1,
      showWhen: { field: 'showDivider', equals: true },
    },

    // Custom CSS
    {
      key: 'customCSS',
      type: 'customCSS',
      label: 'Custom CSS',
      category: 'Advanced',
      default: '',
    },
  ],

  // Render function - will be implemented in the unified renderer
  render: null,
};

export default spacerComponent;
